/**
 * @file 沙箱测试
 * @author fuqiang15
 */

import FormModel from './ApiFormModel';
import {get} from 'lodash';

export default class CustomServiceFormModel extends FormModel {
    formData = {
        parameters: []
    };

    apiDetail = null;

    methodMap = this.getConstantMap('API_REQUEST_METHOD');

    protocolMap = this.getConstantMap('API_PROTOCOL');

    contentTypeMap = this.getConstantMap('API_CONTENT_TYPE');

    init() {
        super.init();

        // 不管创建页面还是详情页面都要请求
        this.apiDetailRequster = this.api.appServiceCustomAPIDetail;
        // 因为有验证，可以不用form
        this.updateRequester = this.api.appServiceCustomAPITest;
    }

    async requestApiDetail() {
        let serviceId = this.getRouteParams().serviceId;
        this.apiDetail = await this.apiDetailRequster({id: this.id});
        let serviceDetail = await this.api.appServiceDetail({id: serviceId});
        this.apiDetail.appId = serviceDetail.appId;
        try {
            this.formData.parameters = JSON.parse(get(this.apiDetail, 'parameters'));
        }
        catch (e) {
            // noop
        }
    }

    prepareData(data) {
        let params = {};
        this.formData.parameters.forEach(
            item => {
                params[item.name] = item.testValue;
            }
        );
        return {
            params: JSON.stringify(params),
            id: this.id
        };
    }

    getLastStepUrl() {
        let apiPrefix = `/custom/api/${this.id}`;
        if (this.isAdmin) {
            return `${this.servicePrefix}${apiPrefix}/${this.pageType}`;
        }
        return `${this.appPrefix}${this.servicePrefix}${apiPrefix}/${this.pageType}`;
    }
}
